// ✅ translate.pipe.ts
import {
  Pipe,
  PipeTransform,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { TranslateService } from './translate.service';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'translate',
  pure: false,
  standalone: false,
})
export class TranslatePipe implements PipeTransform {
  // constructor(private translateService: TranslateService) {}



  private translation!: string;

  constructor(
    private translateService: TranslateService,
  ) {
  }

  transform(key: string, params?: { [key: string]: any }) {
    return this.translateService.get$(key, params);
  }

  // ngOnDestroy() {
  //   this.sub?.unsubscribe();
  // }
}
